import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CheckClockService } from '../../services/check-clock.service';
import { EmployeeService } from '../../services/employee.service';

import { Utils } from '../../util';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-read-registered-employees',
    templateUrl: './read-registered-employees.component.html',
    styleUrls: ['./read-registered-employees.component.css', '../../app.component.css']
})

export class ReadRegisteredEmployeesComponent implements OnInit, OnDestroy {

    registeredEmployees: any[] = [];

    registeredEmployeesNumber: number;

    data: Array<any>;
    rows: Array<any> = [];
    columns: Array<any> = [
        { title: 'Empleado', name: 'employeeName' },
        { title: 'Folio', className: 'center', name: 'folio' },
        { title: 'Fecha registro', className: 'center', name: 'registrationDatetime' },
        { title: 'Entrada / Salida', className: 'center', name: 'type' }
    ];

    page = 1;
    itemsPerPage = 10;
    maxSize = 5;
    numPages = 1;
    length = 0;
    config: any = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' }
    };

    checkClockLoad: any;

    gewfSubs: Subscription;
    gccreSubs: Subscription;
    paramSub: Subscription;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private checkClockService: CheckClockService,
                private employeeService: EmployeeService) {
        this.paramSub = this.activatedRoute.parent.params.subscribe(parameters => {
            this.checkClockLoad = parameters['id'];

            this.loadCheckClocks();
        });
    }

    ngOnInit() {

    }
    ngOnDestroy(){
        this.paramSub.unsubscribe();
    }

    loadCheckClocks() {
        this.gewfSubs = this.employeeService.getEmployeesWithFolio().subscribe(employeesTemp => {
            this.gewfSubs.unsubscribe();

            const employees = [];

            for (const idx in employeesTemp) {
                employees[employeesTemp[idx].id$] = employeesTemp[idx].name + ' ' + employeesTemp[idx].lastName;
            }

            this.gccreSubs = this.checkClockService.getCheckClocksRegisteredEmployees(this.checkClockLoad).subscribe(checkClocksTemp => {
                this.gccreSubs.unsubscribe();

                this.registeredEmployees = [];

                let currentFolio = 0;
                let employeesCont = 0;

                for (const idx in checkClocksTemp) {
                    checkClocksTemp[idx].employeeName = employees[checkClocksTemp[idx].employeeId];

                    if (currentFolio !== checkClocksTemp[idx].folio) {
                        currentFolio = checkClocksTemp[idx].folio;
                        employeesCont = employeesCont + 1;
                    }

                    checkClocksTemp[idx].registrationDatetime = Utils.getDateTime(checkClocksTemp[idx].registrationDatetime);

                    checkClocksTemp[idx].type = (checkClocksTemp[idx].type === 0) ? 'Entrada' :
                                                (checkClocksTemp[idx].type === 1) ? 'Salida' : 'Otro';

                    this.registeredEmployees.push(checkClocksTemp[idx]);
                }

                this.registeredEmployeesNumber = employeesCont;

                this.data = this.registeredEmployees;
                this.length = this.data.length;
                this.onChangeTable(this.config);
            });
        });
    }



    // *************** Table functionality *************** //
    changePage(page: any, data: Array<any> = this.data): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

        return data.slice(start, end);
    }

    changeSort(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        let columns = this.config.sorting.columns;
        let columnName: string;
        let sort: string;

        for (let i = 0; i < columns.length; i++) {
          if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            if (previous[columnName] > current[columnName]) {
                return sort === 'desc' ? -1 : 1;
            } else if (previous[columnName] < current[columnName]) {
                return sort === 'asc' ? -1 : 1;
            }

            return 0;
        });
    }

    changeFilter(data: any, config: any): any {
        let filteredData: Array<any> = data;

        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString);
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
        }

        let tempArray: Array<any> = [];

        filteredData.forEach((item: any) => {
            let flag = false;

            this.columns.forEach((column: any) => {
                if (item[column.name] &&
                    item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
                    flag = true;
                }
            });

            if (flag) {
                tempArray.push(item);
            }
        });

        filteredData = tempArray;

        return filteredData;
    }

    onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
        if (config.filtering) {
            Object.assign(this.config.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.config.sorting, config.sorting);
        }

        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);

        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.length = sortedData.length;
    }

}
